import { precio, duracion } from '../lib/formato.js';
import { FlechaDerecha } from '../componentes/Iconos.jsx';
import { ListaCargando } from '../componentes/Cargando.jsx';
import { Estado } from '../componentes/Estado.jsx';

export function PasoServicio({ servicios, cargando, error, elegido, onElegir, onReintentar }) {
  if (cargando) return <ListaCargando filas={3} />;

  if (error) {
    return (
      <Estado icono="sinSenal" titulo="No pudimos cargar los servicios" accion={onReintentar} etiquetaAccion="Probar de nuevo">
        <p>{error}</p>
      </Estado>
    );
  }

  // Un negocio recién dado de alta todavía no cargó nada. No es un error del
  // sistema y no tiene por qué parecerlo.
  if (servicios.length === 0) {
    return (
      <Estado icono="calendario" titulo="Todavía no hay servicios cargados">
        <p>Este negocio está terminando de configurar su agenda. Escribile directamente para sacar turno.</p>
      </Estado>
    );
  }

  return (
    <div className="lista">
      {servicios.map((servicio) => (
        <button
          key={servicio.id}
          type="button"
          className="opcion"
          aria-pressed={elegido?.id === servicio.id}
          onClick={() => onElegir(servicio)}
        >
          <span className="opcion-cuerpo">
            <span className="opcion-nombre">{servicio.nombre}</span>
            <span className="opcion-detalle">{duracion(servicio.duracion_minutos)}</span>
          </span>
          {servicio.precio_centavos > 0 && (
            <span className="opcion-precio">{precio(servicio.precio_centavos)}</span>
          )}
          <FlechaDerecha className="opcion-flecha" />
        </button>
      ))}
    </div>
  );
}
